var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480.001 480.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,0H112c-4.418,0-8,3.582-8,8v120h16V16h344v440c0.077,4.207-3.169,7.731-7.368,8c-0.688,0-1.376-0.056-2.064-0.072     c-1.416-0.04-2.832-0.072-4.224-0.216c-0.12,0-0.232,0-0.352-0.048c-26.128-2.856-46.767-23.475-49.648-49.6     c0-0.112-0.04-0.232-0.056-0.344c-0.194-1.901-0.29-3.81-0.288-5.72v-16c0-4.418-3.582-8-8-8H120V240h-16v144H40     c-4.418,0-8,3.582-8,8v16c0.044,39.746,32.254,71.956,72,72h352.8c12.982-0.34,23.3-11.014,23.2-24V8C480,3.582,476.418,0,472,0z      M104,464c-30.913-0.035-55.965-25.087-56-56v-8h336v8c0.011,2.638,0.163,5.274,0.456,7.896c0.072,0.696,0.208,1.368,0.304,2.056     c0.264,1.936,0.584,3.864,1.008,5.76c0.144,0.664,0.328,1.32,0.496,1.984c0.488,1.928,1.04,3.824,1.68,5.696     c0.184,0.536,0.376,1.064,0.576,1.6c0.728,1.984,1.552,3.92,2.456,5.832c0.192,0.392,0.368,0.8,0.56,1.16     c1.003,2.027,2.104,3.997,3.304,5.912c0.16,0.256,0.304,0.52,0.464,0.8c1.304,2.043,2.712,4.019,4.216,5.92l0.256,0.344     c1.746,2.193,3.616,4.284,5.6,6.264c1.723,1.707,3.509,3.307,5.36,4.8L104,464z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,224c2.122,0,4.156-0.844,5.656-2.344l32-32c3.123-3.124,3.123-8.188,0-11.312l-32-32     c-1.5-1.5-3.534-2.344-5.656-2.344H40c-22.091,0-40,17.909-40,40s17.909,40,40,40H264z M261.936,161.248L284.688,184     l-22.752,22.752L256.248,184L261.936,161.248z M64,160h181.76l-4,16H80v16h161.76l4,16H64V160z M16,184c0-13.255,10.745-24,24-24     h8v48h-8C26.745,208,16,197.255,16,184z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,344h240c4.418,0,8-3.582,8-8V96c-0.001-4.418-3.583-7.999-8.002-7.998c-2.121,0-4.154,0.843-5.654,2.342l-240,240     c-3.124,3.125-3.123,8.19,0.002,11.314C179.846,343.157,181.879,344,184,344z M416,115.312V136h-16v16h16v16h-16v16h16v16h-16v16     h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16     v-16h-16v16h-20.688L416,115.312z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,296H376c4.418,0,8-3.582,8-8v-76.12c-0.001-4.418-3.583-7.999-8.002-7.998c-2.121,0-4.154,0.843-5.654,2.342     l-76.12,76.12c-3.124,3.125-3.123,8.19,0.002,11.314C295.726,295.157,297.759,296,299.88,296z M368,231.2V280h-48.8L368,231.2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 48,
    width: 160,
    height: 16,
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 80,
    width: 208,
    height: 16,
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 248,
    width: 48,
    height: 16,
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 280,
    width: 32,
    height: 16,
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.b8373a2e0f3c6addf48ef60f4e754eca.svg";
export { ForwardRef as ReactComponent };